import TrackingService from '@/services/tracking';
import { theme } from '@/styles';
import ConstructionCaseCard from '@/ui/ConstructionCaseCard';
import ArrowRight20Icon from '@/ui/Icons/ArrowRight20Icon';
import { ApiPagingResponseData } from '@remodeling/base';
import { ConstructionCaseContent } from '@remodeling/content';
import React from 'react';
import styled from 'styled-components';

interface ConstructionProps {
  type?: string;
  constructData?: ApiPagingResponseData<ConstructionCaseContent>;
  handleConstructionPopup: () => void;
  gtmValue?: Record<string, any>;
}

const Construction = ({
  type,
  constructData,
  handleConstructionPopup,
  gtmValue,
}: ConstructionProps) => {
  return (
    <Container
      {...TrackingService.tagGTM(`constructioncase_list_preview`, gtmValue)}
    >
      <HeaderContainer>
        <TitleContainer>
          <Title>{type && `${type} `}시공사례</Title>
          <DataAmount>({constructData?.totalElements})</DataAmount>
        </TitleContainer>
        {constructData && constructData?.totalElements > 4 && (
          <MoreContainer
            onClick={handleConstructionPopup}
            {...TrackingService.tagGTM(
              `constructioncase_list_preview_more_button`,
              gtmValue,
            )}
          >
            <MoreTitle>더보기</MoreTitle>
            <ArrowRight20Icon fill={theme.colors.neutral_colors.gray[700]} />
          </MoreContainer>
        )}
      </HeaderContainer>
      <CardWrap>
        {constructData?.content.map(
          (item, index) =>
            index < 4 && (
              <CardBox key={item.id} width={'375px'}>
                <ConstructionCaseCard
                  item={item}
                  imgSize={{ width: '375px', height: '211px' }}
                />
              </CardBox>
            ),
        )}
      </CardWrap>
    </Container>
  );
};

export default Construction;

const Container = styled.div`
  margin-bottom: 80px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  color: ${theme.colors.accent_colors.primary.default};
`;

const Title = styled.div`
  ${theme.typography.subtitle4};
`;

const DataAmount = styled.div`
  ${theme.typography.body1};
`;

const MoreContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.neutral_colors.gray[700]};
`;

const MoreTitle = styled.div``;

const CardWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 28px 20px;
`;

const CardBox = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`;
